// extracted by mini-css-extract-plugin
export default {"container":"VoXYW","label":"_81q-e","tooltip":"NgCCj"};